import WhiteTooltip from "./white-tooltip";

export default { WhiteTooltip };
